import { FrameCorners } from "../components/Framed"

interface MainMenuScreenProps {
  canContinue: boolean
  onNewGame: () => void
  onContinue: () => void
  onSettings: () => void
}

export function MainMenuScreen({
  canContinue,
  onNewGame,
  onContinue,
  onSettings,
}: MainMenuScreenProps) {
  return (
    // The title illustration — a lone knight, his fallen loop-selves, and the
    // Necromancer's citadel across a bruised dusk — sits full-bleed behind the
    // whole menu, with the choices floated on a softly lit tablet over it.
    <div className="menu-backdrop">
      <div className="screen main-menu-screen framed">
        <FrameCorners />
        <h1>Echoes Before Eternity</h1>
        <p className="subtitle">A fantasy time-loop strategy RPG.</p>
        <div className="menu-actions">
          <button type="button" onClick={onNewGame}>
            New Game
          </button>
          <button type="button" onClick={onContinue} disabled={!canContinue}>
            Continue
          </button>
          <button type="button" onClick={onSettings}>
            Settings
          </button>
        </div>
      </div>
    </div>
  )
}
